export default __webpack_public_path__ + "1bc216a68f1ed0b73792a5fd22c0c761.svg";